import * as React from 'react';
import styled from "styled-components";
import { Button, Grid, Message, Modal, Table, Tag, Typography } from "@arco-design/web-react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { DeleteApi, PostApi } from "../../Api/AuthenticatedApi";
import { variantRates } from "../broadcastStats";

const { Row, Col } = Grid;
const { Title, Text } = Typography;

// MUI -> Arco. makeStyles -> styled-components (active/inactive card variants).
// Grid2 /12 -> Arco Grid /24 (xs={12} doubled to span={24}). The MUI Table/
// TableBody/TableRow/TableCell stats grid is rewritten into an Arco Table with
// a columns config + data array. Typography -> Title/Text. The unused `bull`
// helper from the old template was dropped.

const activeCardStyle = {
    padding: "10px",
    background: "var(--color-bg-2)",
    maxWidth: "300px",
};

const inactiveCardStyle = {
    background: "var(--color-fill-2)",
    padding: "10px",
    maxWidth: "300px",
};

const Card = styled.div`
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.08);
`;

const CardContent = styled.div`
    padding: 16px;
`;

const CardActions = styled.div`
    display: flex;
    gap: 8px;
    padding: 8px;
`;

const statColumns = [
    { title: "", dataIndex: "label" },
    { title: "", dataIndex: "value" },
];

function numberToChar(n) {
    // Assuming n is in the range 0-25
    if (n >= 0 && n <= 25) {
        return String.fromCharCode('A'.charCodeAt(0) + n);
    } else {
        return (n + 1) + "";
    }
}

export default function MailVariantCard(props) {
    let { item, index, broadcastId, editable, isWinner, onChanged } = props;
    let cardStyle = inactiveCardStyle;
    let state = "paused";
    let navigate = useNavigate();
    const { getAccessTokenSilently } = useAuth0();

    const baseUrl = "/api/broadcasts/" + broadcastId + "/mailvariants/" + item.id;

    const cloneVariant = () => {
        PostApi(getAccessTokenSilently, baseUrl + "/duplicate",
            () => { Message.success("Email cloned"); onChanged && onChanged(); },
            () => navigate("/login"),
            () => Message.error("Failed to clone email"));
    };

    const deleteVariant = () => {
        Modal.confirm({
            title: "Delete this email?",
            content: "This can't be undone.",
            okButtonProps: { status: "danger" },
            okText: "Delete",
            onOk: () => {
                DeleteApi(getAccessTokenSilently, baseUrl,
                    () => { Message.success("Email deleted"); onChanged && onChanged(); },
                    () => navigate("/login"),
                    () => Message.error("Failed to delete email"));
            },
        });
    };


    if (item.should_run) {
        cardStyle = activeCardStyle;
        state = "active";
    }

    const rates = variantRates(item);
    const statData = [
        { key: "sent", label: "Sent", value: item.sent },
        { key: "opens", label: "Opens", value: item.opens },
        { key: "openRate", label: "Open rate", value: rates.openRate },
        { key: "clicks", label: "Clicks", value: item.clicks },
        { key: "clickRate", label: "Click rate", value: rates.clickRate },
        { key: "state", label: "State", value: state },
    ];

    return (
        <Card style={cardStyle}>
            <CardContent>
                <Row>
                    <Col span={24}>
                        <Title heading={6} style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                            {"Email " + numberToChar(index)}
                            {isWinner && <Tag size="small" color="green">🏆 Leading</Tag>}
                        </Title>
                    </Col>
                    <Col span={24}>
                        <Text style={{ minHeight: 20 }}>{item.mail_subject_template} </Text>
                    </Col>
                    <Col span={24}>
                        <div style={{ overflowX: "clip" }}>
                            <Table
                                size="small"
                                showHeader={false}
                                columns={statColumns}
                                data={statData}
                                rowKey="key"
                                pagination={false}
                                border={false}
                            />
                        </div>
                    </Col>
                </Row>
            </CardContent>

            <CardActions>
                {editable ? (
                    <>
                        <Button type="outline" size="small" onClick={() => navigate(`/broadcasts/` + broadcastId + `/email/` + item.id)}>Edit</Button>
                        <Button type="outline" size="small" onClick={cloneVariant}>Clone</Button>
                        <Button type="outline" size="small" status="danger" onClick={deleteVariant}>Delete</Button>
                    </>
                ) : (
                    <Button type="outline" size="small" onClick={() => navigate(`/broadcasts/` + broadcastId + `/email/` + item.id)}>View</Button>

                )}
            </CardActions>
        </Card>
    );
}
